/**
 * @generated SignedSource<<92290e874bdf6c12e630d42443487696>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type translateQuery$variables = {
  context?: string | null;
  from: string;
  fromLang: string;
  toLang: string;
  withSvg?: boolean | null;
};
export type translateQuery$data = {
  readonly translate: {
    readonly svg: {
      readonly flatId: string;
      readonly url: string;
    } | null;
    readonly translate: string;
  };
};
export type translateQuery = {
  response: translateQuery$data;
  variables: translateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromLang"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "toLang"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withSvg"
},
v5 = [
  {
    "kind": "Variable",
    "name": "context",
    "variableName": "context"
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "fromLang",
    "variableName": "fromLang"
  },
  {
    "kind": "Variable",
    "name": "toLang",
    "variableName": "toLang"
  },
  {
    "kind": "Variable",
    "name": "withSvg",
    "variableName": "withSvg"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flatId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "translateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "TranslateResponse",
        "kind": "LinkedField",
        "name": "translate",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Upload",
            "kind": "LinkedField",
            "name": "svg",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "translateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "TranslateResponse",
        "kind": "LinkedField",
        "name": "translate",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Upload",
            "kind": "LinkedField",
            "name": "svg",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8dee4d193850e8e6f3f85284d354b2a5",
    "id": null,
    "metadata": {},
    "name": "translateQuery",
    "operationKind": "query",
    "text": "query translateQuery(\n  $from: String!\n  $fromLang: String!\n  $toLang: String!\n  $withSvg: Boolean\n  $context: String\n) {\n  translate(from: $from, fromLang: $fromLang, toLang: $toLang, withSvg: $withSvg, context: $context) {\n    translate\n    svg {\n      flatId\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "16fa8da195843baba317bb1c173124b8";

export default node;
